import type { ThemeProps } from '@models/types';
import type { SxProps, Theme } from '@mui/material';

export const getCustomPartnerFinishSx = (theme: ThemeProps) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        p: '16px 16px 0 16px',
        gap: 2,
        height: '100%',
    } satisfies SxProps<Theme>,

    divider: {
        width: '100%',
        maxWidth: 872,
        height: '1px',
        bgcolor: theme.palette.secondaryA10,
    } satisfies SxProps<Theme>,

    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
        maxWidth: 650,
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    } satisfies SxProps<Theme>,

    title: {
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
        mt: 2,
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    } satisfies SxProps<Theme>,

    description: {
        pb: 2,
        textAlign: 'center',
        lineHeight: '20px',
        whiteSpace: 'pre-line',
        [theme.breakpoints.down('md')]: {
            textAlign: 'left',
        },
    } satisfies SxProps<Theme>,

    actions: {
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
    } satisfies SxProps<Theme>,

    redirectButton: {
        width: '100%',
    } satisfies SxProps<Theme>,

    redirectHint: {
        textAlign: 'center',
        lineHeight: '20px',
    } satisfies SxProps<Theme>,

    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        py: 7,
    } satisfies SxProps<Theme>,
    image: {
        width: 260,
        height: 260,
        mb: 0,
        ml: 'auto',
        mt: 'auto',
        pt: 2,
    },
});
